<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Picking Supply For Production" active>

                                <b-row v-if="hasFailedDataPickingSupplyForProduction">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPickingSupplyForProduction.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingSupplyForProductionsFailed" :fields="fieldsPickingSupplyForProduction" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingSupplyForProduction" :sort-desc.sync="sortDescPickingSupplyForProduction" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(workOrderSupplyDate)="row">
													{{ row.item.workOrderSupplyDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPickingSupplyForProduction.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingSupplyForProductions" :fields="fieldsPickingSupplyForProduction" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingSupplyForProduction" :sort-desc.sync="sortDescPickingSupplyForProduction" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(workOrderSupplyDate)="row">
													{{ row.item.workOrderSupplyDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Picking Supply For Production Detail" active>

                                <b-row v-if="hasFailedDataPickingSupplyForProductionDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPickingSupplyForProductionDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingSupplyForProductionDetailsFailed" :fields="fieldsPickingSupplyForProductionDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingSupplyForProductionDetail" :sort-desc.sync="sortDescPickingSupplyForProductionDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtySupply)="row">
													{{ Number(row.item.qtySupply).toLocaleString() }}
												</template>
												<template #cell(qtyOutstanding)="row">
													{{ Number(row.item.qtyOutstanding).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPickingSupplyForProductionDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingSupplyForProductionDetails" :fields="fieldsPickingSupplyForProductionDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingSupplyForProductionDetail" :sort-desc.sync="sortDescPickingSupplyForProductionDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtySupply)="row">
													{{ Number(row.item.qtySupply).toLocaleString() }}
												</template>
												<template #cell(qtyOutstanding)="row">
													{{ Number(row.item.qtyOutstanding).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>
                            <b-tab title="Upload Picking Supply For Production Case" active>

                                <b-row v-if="hasFailedDataPickingSupplyForProductionCase">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPickingSupplyForProductionCase.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingSupplyForProductionCasesFailed" :fields="fieldsPickingSupplyForProductionCase" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingSupplyForProductionCase" :sort-desc.sync="sortDescPickingSupplyForProductionCase" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qty)="row">
													{{ Number(row.item.qty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPickingSupplyForProductionCase.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingSupplyForProductionCases" :fields="fieldsPickingSupplyForProductionCase" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingSupplyForProductionCase" :sort-desc.sync="sortDescPickingSupplyForProductionCase" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qty)="row">
													{{ Number(row.item.qty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>
                            <b-tab title="Upload Picking Supply For Production Suggestion" active>

                                <b-row v-if="hasFailedDataPickingSupplyForProductionSuggestion">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedPickingSupplyForProductionSuggestion.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingSupplyForProductionSuggestionsFailed" :fields="fieldsPickingSupplyForProductionSuggestion" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingSupplyForProductionSuggestion" :sort-desc.sync="sortDescPickingSupplyForProductionSuggestion" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qty)="row">
													{{ Number(row.item.qty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedPickingSupplyForProductionSuggestion.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="pickingSupplyForProductionSuggestions" :fields="fieldsPickingSupplyForProductionSuggestion" :busy="isDataLoading"
                                                         :sort-by.sync="sortByPickingSupplyForProductionSuggestion" :sort-desc.sync="sortDescPickingSupplyForProductionSuggestion" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qty)="row">
													{{ Number(row.item.qty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import PickingSupplyForProduction from '@/models/PickingSupplyForProduction/PickingSupplyForProduction';
import PickingSupplyForProductionList from '@/models/PickingSupplyForProduction/PickingSupplyForProductionList';
import PickingSupplyForProductionFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsPickingSupplyForProduction: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Work Order Supply", key: 'workOrderSupplyWorkOrderSupplyDate', sortable: false},
				{"class" : "th-status", "label" : "Work Order Process", key: 'workOrderProcessWorkOrderProcessNumber', sortable: false},
				{"class" : "th-status", "label" : "Work Order Supply Date", key: 'workOrderSupplyDate', sortable: false},
				{"class" : "th-status", "label" : "Document Status", key: 'documentStatusName', sortable: false},
				{"class" : "th-status", "label" : "Line", key: 'lineCode', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsPickingSupplyForProductionDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Material Part", key: 'materialPartPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty Supply", key: 'qtySupply', sortable: false},
				{"class" : "th-status", "label" : "Qty Outstanding", key: 'qtyOutstanding', sortable: false},
				{"class" : "th-status", "label" : "Remark", key: 'remark', sortable: false},
				{"class" : "th-status", "label" : "DocumentStatus", key: 'documentStatusName', sortable: false},
				{"class" : "th-status", "label" : "Work Order Supply Detail", key: 'workOrderSupplyDetailMaterialPart', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsPickingSupplyForProductionCase: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Picking Supply For Production Detail", key: 'pickingSupplyForProductionDetailMaterialPart', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty", key: 'qty', sortable: false},
				{"class" : "th-status", "label" : "Remark", key: 'remark', sortable: false},
				{"class" : "th-status", "label" : "Document Status", key: 'documentStatusName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsPickingSupplyForProductionSuggestion: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Picking Supply For Production Detail", key: 'pickingSupplyForProductionDetailMaterialPart', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty", key: 'qty', sortable: false},
				{"class" : "th-status", "label" : "Is Picking", key: 'isPicking', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			pickingSupplyForProductions : [],
			pickingSupplyForProductionsFailed: [],
			pickingSupplyForProductionId : '',
			sortByPickingSupplyForProduction: '',
			sortDescPickingSupplyForProduction: '',
			hasFailedDataPickingSupplyForProduction: false,
			totalFailedPickingSupplyForProduction: 0,
			totalSucceedPickingSupplyForProduction: 0,
			pickingSupplyForProductionDetails : [],
			pickingSupplyForProductionDetailsFailed: [],
			pickingSupplyForProductionDetailId : '',
			sortByPickingSupplyForProductionDetail: '',
			sortDescPickingSupplyForProductionDetail: '',
			hasFailedDataPickingSupplyForProductionDetail: false,
			totalFailedPickingSupplyForProductionDetail: 0,
			totalSucceedPickingSupplyForProductionDetail: 0,

			pickingSupplyForProductionCases : [],
			pickingSupplyForProductionCasesFailed: [],
			pickingSupplyForProductionCaseId : '',
			sortByPickingSupplyForProductionCase: '',
			sortDescPickingSupplyForProductionCase: '',
			hasFailedDataPickingSupplyForProductionCase: false,
			totalFailedPickingSupplyForProductionCase: 0,
			totalSucceedPickingSupplyForProductionCase: 0,

			pickingSupplyForProductionSuggestions : [],
			pickingSupplyForProductionSuggestionsFailed: [],
			pickingSupplyForProductionSuggestionId : '',
			sortByPickingSupplyForProductionSuggestion: '',
			sortDescPickingSupplyForProductionSuggestion: '',
			hasFailedDataPickingSupplyForProductionSuggestion: false,
			totalFailedPickingSupplyForProductionSuggestion: 0,
			totalSucceedPickingSupplyForProductionSuggestion: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('pickingsupplyforproduction/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('pickingsupplyforproduction/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getPickingSupplyForProductionForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getPickingSupplyForProductionForUpload : async function() {
			let _this = this;
			this.$http.get('pickingsupplyforproduction/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.pickingSupplyForProductions = [];
_this.pickingSupplyForProductionDetails = [];
_this.pickingSupplyForProductionCases = [];
_this.pickingSupplyForProductionSuggestions = [];


					if (response != null) {
						let result = response.data;
						_this.pickingSupplyForProductions = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedPickingSupplyForProduction = _this.pickingSupplyForProductions.length;

						_this.pickingSupplyForProductionsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataPickingSupplyForProduction = true;
						_this.totalFailedPickingSupplyForProduction = 0;
						if(_this.pickingSupplyForProductionsFailed == undefined || _this.pickingSupplyForProductionsFailed.length === 0) _this.hasFailedDataPickingSupplyForProduction = false;
						if(_this.hasFailedDataPickingSupplyForProduction) _this.totalFailedPickingSupplyForProduction = _this.pickingSupplyForProductionsFailed.length;
						_this.pickingSupplyForProductionDetails = [];
						_this.pickingSupplyForProductionDetailsFailed = [];
						_this.hasFailedDataPickingSupplyForProductionDetail = true;
						_this.totalSucceedPickingSupplyForProductionDetail = 0;
						result.forEach(function(element) {
							_this.pickingSupplyForProductionDetails.push(...element.pickingSupplyForProductionDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedPickingSupplyForProductionDetail = _this.pickingSupplyForProductionDetails.length;

							_this.pickingSupplyForProductionDetailsFailed.push(...element.pickingSupplyForProductionDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.pickingSupplyForProductionDetailsFailed == undefined || _this.pickingSupplyForProductionDetailsFailed.length === 0) _this.hasFailedDataPickingSupplyForProductionDetail = false;
							if(_this.hasFailedDataPickingSupplyForProductionDetail) _this.totalFailedPickingSupplyForProductionDetail = _this.pickingSupplyForProductionDetailsFailed.length;
						});						_this.pickingSupplyForProductionCases = [];
						_this.pickingSupplyForProductionCasesFailed = [];
						_this.hasFailedDataPickingSupplyForProductionCase = true;
						_this.totalSucceedPickingSupplyForProductionCase = 0;
						result.forEach(function(element) {
							_this.pickingSupplyForProductionCases.push(...element.pickingSupplyForProductionCase.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedPickingSupplyForProductionCase = _this.pickingSupplyForProductionCases.length;

							_this.pickingSupplyForProductionCasesFailed.push(...element.pickingSupplyForProductionCase.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.pickingSupplyForProductionCasesFailed == undefined || _this.pickingSupplyForProductionCasesFailed.length === 0) _this.hasFailedDataPickingSupplyForProductionCase = false;
							if(_this.hasFailedDataPickingSupplyForProductionCase) _this.totalFailedPickingSupplyForProductionCase = _this.pickingSupplyForProductionCasesFailed.length;
						});						_this.pickingSupplyForProductionSuggestions = [];
						_this.pickingSupplyForProductionSuggestionsFailed = [];
						_this.hasFailedDataPickingSupplyForProductionSuggestion = true;
						_this.totalSucceedPickingSupplyForProductionSuggestion = 0;
						result.forEach(function(element) {
							_this.pickingSupplyForProductionSuggestions.push(...element.pickingSupplyForProductionSuggestion.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedPickingSupplyForProductionSuggestion = _this.pickingSupplyForProductionSuggestions.length;

							_this.pickingSupplyForProductionSuggestionsFailed.push(...element.pickingSupplyForProductionSuggestion.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.pickingSupplyForProductionSuggestionsFailed == undefined || _this.pickingSupplyForProductionSuggestionsFailed.length === 0) _this.hasFailedDataPickingSupplyForProductionSuggestion = false;
							if(_this.hasFailedDataPickingSupplyForProductionSuggestion) _this.totalFailedPickingSupplyForProductionSuggestion = _this.pickingSupplyForProductionSuggestionsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'pickingsupplyforproduction/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'PickingSupplyForProduction.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterPickingSupplyForProduction = new PickingSupplyForProductionFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
